import clsx from 'clsx';
import React from 'react';

const sizes = {
  sm: 'size-4',
  md: 'size-8',
  lg: 'size-16',
  xl: 'size-24'
};

const styles = {
  base: [
    'inline-block animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]'
  ],
  colors: {
    'dark/zinc': 'text-zinc-900 dark:text-zinc-600',
    'light': 'text-white dark:text-zinc-800',
    'dark/white': 'text-zinc-900, dark:text-white',
    'dark': 'text-zinc-900 dark:text-zinc-800',
    'white': 'text-white',
    'zinc': 'text-zinc-600',
    'indigo': 'text-indigo-500',
    'cyan': 'text-cyan-300',
    'red': 'text-red-600',
    'orange': 'text-orange-500',
    'amber': 'text-amber-400',
    'yellow': 'text-yellow-300',
    'lime': 'text-lime-300',
    'green': 'text-green-600',
    'emerald': 'text-emerald-600',
    'teal': 'text-teal-600',
    'sky': 'text-sky-500',
    'blue': 'text-blue-600',
    'violet': 'text-violet-500',
    'purple': 'text-purple-500',
    'fuchsia': 'text-fuchsia-500',
    'pink': 'text-pink-500',
    'rose': 'text-rose-500'
  }
};

export function Spinner({
  size = 'md',
  color = 'dark/zinc',
  className,
  message = 'Loading...',
  ...props
}: {
  size?: keyof typeof sizes;
  message?: string;
  color?: keyof typeof styles.colors;
} & React.ComponentPropsWithoutRef<'span'>) {
  return (
    <>
      <span
        className={clsx(
          styles.base,
          sizes[size],
          styles.colors[color],
          className
        )}
        {...props}
      />
      <span className="sr-only">{message}</span>
    </>
  );
}
